module.exports = __webpack_public_path__ + "static/media/expand.c702995f.svg";